import React from "react";
import { orderStatus, russianMonth } from "../../../util";

const dateFormat = (date) => {
    return `${date.getDate()} ${russianMonth[date.getMonth() + 1].slice(0, 3)}, ${date.getFullYear()}`;
}

const LkDeliveryTableEl = (props) => {

    let statusText;
    let statusStyleBg
    let statusStyleColor
    switch (orderStatus(props.el)) {
        case "in_progress":
            statusText = `${props.data.LkDelivery.DeliveryStatuses.process.text}`;
            statusStyleBg = props.data.LkDelivery.DeliveryStatuses.process.bgColor;
            statusStyleColor = props.data.LkDelivery.DeliveryStatuses.process.color;
            break;
        case "done":
            statusText = `${props.data.LkDelivery.DeliveryStatuses.completed.text}`;
            statusStyleBg = props.data.LkDelivery.DeliveryStatuses.completed.bgColor;
            statusStyleColor = props.data.LkDelivery.DeliveryStatuses.completed.color;
            break;
        case "aborted":
            statusText = `${props.data.LkDelivery.DeliveryStatuses.сancelled.text}`;
            statusStyleBg = props.data.LkDelivery.DeliveryStatuses.сancelled.bgColor;
            statusStyleColor = props.data.LkDelivery.DeliveryStatuses.сancelled.color;
            break;
    }


    let typeText;
    let typeImage
    switch (props.el.delivery_type) {
        case "avia":
            typeText = `${props.data.LkDelivery.TypeOrder.avia.text}`;
            typeImage = `${props.data.LkDelivery.TypeOrder.avia.image}`
            break;
        case "auto":
            typeText = `${props.data.LkDelivery.TypeOrder.avto.text}`
            typeImage = `${props.data.LkDelivery.TypeOrder.avto.image}`
            break;
        case "train":
            typeText = `${props.data.LkDelivery.TypeOrder.poezd.text}`
            typeImage = `${props.data.LkDelivery.TypeOrder.poezd.image}`
            break;
        case "ship":
            typeText = `${props.data.LkDelivery.TypeOrder.ship.text}`
            typeImage = `${props.data.LkDelivery.TypeOrder.ship.image}`
            break;
    }

    const maxDeliveryDays = parseInt(props.el.delivery_time.split('-')[1]);
    let finalDate = new Date(props.el.created_at);
    finalDate.setDate(finalDate.getDate() + maxDeliveryDays);

    function truncate(str, num) {
        if (str.length <= num) {
            return str;
        } else {
            str = str.slice(0, num);
            return str + "...";
        }
    }

    return (
        <div className="grid grid-cols-8 gap-[10px] text-[12px] xl:text-[16px] py-[16px] border-b-[2px] border-solid border-[#EFF0F2] items-center">
            <div>{truncate(props.el._id, 10)}</div>
            <div className="bg-[#EFF0F2] flex items-center gap-[8px] rounded-[41px] py-[5px] px-[10px] xl:py-[7px] xl:px-[12px] text-[12px] xl:text-[14px] w-fit">
                <img src={typeImage} alt="avia" />
                <span>{typeText}</span>
            </div>
            <div>{dateFormat(new Date(props.el.created_at))}</div>
            <div>{dateFormat(finalDate)}</div>
            <div className={` rounded-[25px] py-[5px] px-[10px] xl:py-[8px] xl:px-[16px] text-[10px] xl:text-[14px] font-semibold w-fit`}
                style={{
                    backgroundColor: statusStyleBg,
                    color: statusStyleColor
                }}>
                {statusText}
            </div>
            <div>-</div>
            <div>-</div>
            <div>${props.el.delivery_cost + props.el.invoice_cost}</div>
        </div>
    );
}

export default LkDeliveryTableEl;

